import React from 'react';
import { Link } from 'react-router-dom';
import { InfoIcon } from 'lucide-react';
import { useLanguage } from '../../contexts/LanguageContext';
import { pricingTiers } from '../../data/pricing';
import { buttonStyles, container } from '../../utils/styles';
import { SectionHeading } from '../shared/SectionHeading';
export function PricingTable() {
  const {
    t
  } = useLanguage();
  return <section id="pricing" className="scroll-mt-32 bg-white py-20 sm:py-24" aria-labelledby="pricing-heading" data-id="element-212" data-mp="2xpnj0l450l8o">
      <div className={`${container} grid gap-12 lg:grid-cols-12`} data-id="element-213" data-mp="32gnj1z8jzjfe">
        <div className="lg:col-span-4" data-id="element-214" data-mp="32hymtz200r6i">
          <SectionHeading id="pricing-heading" title={t({
          en: 'Pricing Information',
          es: 'Información de Precios'
        })} intro={t({
          en: 'Clear, honest ranges so you can plan. Your exact rate depends on the care needed and the schedule, and is confirmed in your free consultation.',
          es: 'Rangos claros y honestos para que puedas planificar. La tarifa exacta depende del cuidado y del horario, y se confirma en tu consulta gratuita.'
        })} data-id="element-215" data-mp="2opifwn5z890b" />
          <Link to="/contact" className={`${buttonStyles.primary} mt-8`} data-id="element-216" data-mp="2gy49jvqpr051">
            {t({
            en: 'Get a Free Estimate',
            es: 'Obtener un Estimado Gratis'
          })}
          </Link>
        </div>
        <div className="lg:col-span-8" data-id="element-217" data-mp="2q0dk2llzetif">
          <div className="overflow-hidden rounded-2xl border border-mist" data-id="element-218" data-mp="2px7wjat03zot">
            <table className="w-full text-left" data-id="element-219" data-mp="22a9dc5dhydn7">
              <caption className="sr-only" data-id="element-220" data-mp="1y8egbd2lmmf8">{t({
                en: 'Estimated home care rates',
                es: 'Tarifas estimadas de cuidado'
              })}</caption>
              <thead className="bg-brand-tint" data-id="element-221" data-mp="2c0ktcqaggdag">
                <tr data-id="element-222" data-mp="2c1dwzie4amod">
                  <th scope="col" className="px-5 py-4 font-semibold text-brand-dark sm:px-6" data-id="element-223" data-mp="278axyuqkml0s">
                    {t({
                    en: 'Type of care',
                    es: 'Tipo de cuidado'
                  })}
                  </th>
                  <th scope="col" className="px-5 py-4 text-right font-semibold text-brand-dark sm:px-6" data-id="element-224" data-mp="1ekf3zxsdz77p">
                    {t({
                    en: 'Estimated range',
                    es: 'Rango estimado'
                  })}
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-mist" data-id="element-225" data-mp="3jk6ovhcwfz1a">
                {pricingTiers.map(tier => <tr key={tier.id} data-id="element-226" data-mp="3odj4j1zlovhw">
                    <th scope="row" className="px-5 py-5 font-normal sm:px-6" data-id="element-227" data-mp="3oekgr9scro17">
                      <span className="block font-semibold text-ink" data-id="element-228" data-mp="3tahxvibfwyf1">{t(tier.name)}</span>
                      <span className="mt-0.5 block text-sm text-ink-soft" data-id="element-229" data-mp="2vpdga59c8odb">{t(tier.detail)}</span>
                    </th>
                    <td className="whitespace-nowrap px-5 py-5 text-right font-display text-lg font-bold text-brand-dark sm:px-6" data-id="element-230" data-mp="30ogmht1210mv">
                      {t(tier.price)}
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>
          <p className="mt-4 flex items-start gap-2 text-sm text-ink-soft" data-id="element-231" data-mp="kxkcyl5hhzj9">
            <InfoIcon className="mt-0.5 h-4 w-4 shrink-0" aria-hidden="true" data-id="element-232" data-mp="ovi0zkniqfl2" />
            {t({
            en: 'Estimates only. Medication reminders and light housekeeping are included in every plan. Long-term care insurance documentation available.',
            es: 'Solo estimados. Los recordatorios de medicamentos y la limpieza ligera están incluidos en todos los planes. Documentación disponible para seguros de cuidado a largo plazo.'
          })}
          </p>
        </div>
      </div>
    </section>;
}